import React from 'react'

class NotFound extends React.Component {
	render() {
		return (
			<div>
				<p>Not found</p>
			</div>
		)
	}
}

export default NotFound



// WEBPACK FOOTER //
// ./src/NotFound.jsx